import { useEffect, useState } from "react";
import { getDocDataById, queryCollection } from "../models/DataFunctions";
import getControlPresginedUrls from "../api/presigned/getControlPresignedUrls";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";

export const PhotoControlFacadeFolder = ({ folderData, prefix }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleFetchData = async () => {
    setLoading(true);
    let controls = await queryCollection("control", [
      { field: "folder_ref", operator: "==", value: folderData.ref },
    ]);
    let found_control_id;
    let cochamp_index = -1;
    let champ_index = -1;
    if (controls && controls.length > 0) {
      let url = null;
      for (let i = 0; i < controls.length; i++) {
        let control = controls[i];
        let cochamps = control.cochamps || [];
        for (let j = 0; j < cochamps.length; j++) {
          if (cochamps[j].name === "Champs obligatoires") {
            cochamp_index = j;
            let champs = cochamps[j].champs || [];

            for (let k = 0; k < champs.length; k++) {
              let champ = champs[k];

              if (champ.name === "Photos Facade") {
                champ_index = k;
                found_control_id = control.id;
                const token = await getOrRefreshFirebaseToken();
                await getControlPresginedUrls(control.id, token, prefix);
                let fresh_control = await getDocDataById("control", control.id);
                // now get the url from the fresh control
                let fresh_champ =
                  fresh_control.cochamps[cochamp_index].champs[champ_index];
                url = fresh_champ.content[0];

                break;
              }
            }
          }
        }
        if (url) {
          break;
        }
      }
      setUrl(url);
    }
    setLoading(false);

    // get first control
    // get facade
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  if (!url && !loading) {
    return <></>;
  }

  return (
    <div
      className={`w-40 h-20 flex justify-center items-center ${loading ? "animate-pulse bg-gray-200 rounded-md" : ""}`}
    >
      {url && (
        <img
          src={url}
          className={`w-full h-full object-cover rounded-xl `}
          alt="Facade"
        />
      )}
    </div>
  );
};
